/**
 * CHECK24 hostname configuration.
 *
 * Non-prod traffic uses check24-test.at. Legacy check24-int.at hostnames
 * remain accepted via CHECK24_EXTRA_NON_PROD_DOMAINS during DNS cutover.
 */
export const CHECK24_NON_PROD_DOMAIN = 'check24-test.at';

export const CHECK24_PROD_DOMAIN = 'check24.at';

/** Local dev hostnames that use non-prod backends and SSO. */
export const CHECK24_LOCAL_HOSTNAMES = ['localhost', '127.0.0.1'] as const;

/** Legacy non-prod domains still reachable during INT → test migration. */
export const CHECK24_EXTRA_NON_PROD_DOMAINS = ['check24-int.at'] as const;
